module.exports = __webpack_public_path__ + "static/img/Straight.cbf70ea.svg";